module.exports = __webpack_public_path__ + "static/media/TIMO_Logo.ed66dd73.png";